import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Alert } from "react-bootstrap";
import { FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import "./AddWorkAllotment.css";
import api from "../services/api";

const WorkAllotmentReturn = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [workerNames, setWorkerNames] = useState([]);
    const [customers, setCustomers] = useState([]);
  
  // const [amount, setAmount] = useState(0);
  const [products, setProducts] = useState([]);
  // Form state
  const [formData, setFormData] = useState({
    id: "",
    worker_id: "",
    allot_date: new Date().toISOString().split('T')[0],
    raw_pid: "",
    raw_name: "",
    finished_pid: "",
    allot_qty: "",
    return_qty: "",
    balance_qty: "",
    amount_per_kg: "",
    amount_total_kg: "",
    note: ""
  });



  // Fetch suppliers and products from API
  useEffect(() => {
    if (id) {
      fetchAllotmentData();
      fetchDropdownData();
    }
  }, [id]);

  const fetchAllotmentData = async () => {
    try {
      //   setFetching(true);
      const response = await api.post("/work_allotment_detail.php", { id });

      if (response.data.head.code === 200) {
        const workAllotment = response.data.body;

        const formatDate = (date) => {
          console.log("API date:", date);
          if (!date) return "";

          // date = "18-12-2025"
          const [day, month, year] = date.split("-");

          return `${year}-${month}-${day}`; // "2025-12-18"
        };

        setFormData({
          id: workAllotment.id,
          worker_id: workAllotment.worker_id,
          raw_pid: workAllotment.raw_pid,
          finished_pid: workAllotment.finished_pid || "",
          allot_date: formatDate(workAllotment.allot_date),
          raw_name: workAllotment.raw_name,
          allot_qty: workAllotment.allot_qty,
          return_qty: workAllotment.return_qty || "",
          balance_qty: workAllotment.balance_qty,
          amount_per_kg: workAllotment.amount_per_kg,
          amount_total_kg: (workAllotment.balance_qty * workAllotment.amount_per_kg).toFixed(2),
          note: workAllotment.note || ""
        });

      } else {
        // setSubmitError("Purchase not found");
      }
    } catch (err) {
      console.error("Error fetching purchase:", err);
      //   setSubmitError("Failed to load purchase data");
    } finally {
      //   setFetching(false);
    }
  };

  const fetchDropdownData = async () => {
    try {
      // Fetch suppliers
      const workerResponse = await api.post("/job_worker_list.php", {});
      if (workerResponse.data.head.code === 200) {
        setWorkerNames(workerResponse.data.body);
      }

      // Fetch customers
      const customerResponse = await api.post("/customer_list.php", {});
      if (customerResponse.data.head.code === 200) {
        setCustomers(customerResponse.data.body);
      }

      

      // Fetch products
      const productsResponse = await api.post("/product_list.php", {});
      if (productsResponse.data.head.code === 200) {
        setProducts(productsResponse.data.body);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);

    }
  };





  // Errors state
  const [errors, setErrors] = useState({});

  // Refs for focus management
  const workerRef = useRef(null);
    const customerRef = useRef(null);

  const dateRef = useRef(null);
  const remarkRef = useRef(null);
  const productFromRef = useRef(null);
  const productToRef = useRef(null);
  const qtyRef = useRef(null);
  const amountPerRef = useRef(null);

  // Handle form field changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Handle Enter key navigation
  const handleKeyDown = (e, nextFieldRef, action = null) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (action) {
        action();
      } else if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  // Delete item from list
  // const handleDeleteItem = (id) => {
  //   setWorkItems(workItems.filter(item => item.id !== id));
  // };

  // Calculate total quantity
  const calculateTotalQuantity = () => {
    // return workItems.reduce((total, item) => total + item.quantity, 0);
    return parseInt(formData.allot_qty) || 0;
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.worker_name) {
      newErrors.worker_name = "Worker name is required";
    }

    if (!formData.date) {
      newErrors.date = "Date is required";
    }

    // if (workItems.length === 0) {
    //   newErrors.items = "At least one product is required";
    // }

    return newErrors;
  };


  // console.log("=== payload =======", payload);


  // const navigatto = () => {
  //     navigate("/workallotment");
  //   }
  // Render error message
  const renderError = (field) => {
    return errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;
  };

  // const getProductNameById = (id) => {
  //   return products.find(p => String(p.id) === String(id))?.name || "";
  // };
  const formatDateToDMY = (date) => {
    if (!date) return "";
    const [yyyy, mm, dd] = date.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Call the supplier_add.php API
      const payload = {
        allotment_id: id,
        customer_id: formData.customer_id,
        return_date: formatDateToDMY(formData.allot_date),
        raw_pid: formData.raw_pid,
        finished_pid: formData.finished_pid,
        return_qty: formData.allot_qty,
        amount_per_return: formData.amount_total_kg,
        amount_per_kg: formData.amount_per_kg,
        note: formData.note
      };
      console.log("payload ", payload);
      /* */
      const response = await api.post("/work_return_add.php", payload);

      if (response.data.head.code === 200) {
        console.log(response.data);
        navigate('/workallotment');
      } else {
        console.log(response.data);
      }

    } catch (err) {
      console.log(err);
    } finally {
    }

  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value === "" ? "" : Number(value),
      };

      const qty = Number(updated.allot_qty) || 0;
      const rate = Number(updated.amount_per_kg) || 0;

      updated.amount_total_kg = (qty * rate).toFixed(2);

      return updated;
    });
  };



  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Work Allotment</h4>
        <Button variant="secondary" onClick={() => navigate("/workallotment")}>
          Back to List
        </Button>
      </div>

      <Form noValidate onSubmit={handleSubmit}>
        <Row className="g-3">
          {/* Worker Selection */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Select Worker *</Form.Label>
              <Form.Select
                ref={workerRef}
                name="worker_id"
                value={formData.worker_id}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, productFromRef)}
                isInvalid={!!errors.worker_id}
              >
                <option value="">Select Worker</option>
                {workerNames.map((worker, index) => (
                  <option key={index} value={worker.id}>
                    {worker.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("worker_id")}
            </Form.Group>
          </Col>

{/* Customer Selection */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Select Customer *</Form.Label>
              <Form.Select
                ref={customerRef}
                name="customer_id"
                value={formData.customer_id}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, productFromRef)}
                isInvalid={!!errors.customer_id}
              >
                <option value="">Select Customer</option>
                {customers.map((customer, index) => (
                  <option key={index} value={customer.id}>
                    {customer.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("customer_id")}
            </Form.Group>
          </Col>

          {/* Product Selection */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Select Product From *</Form.Label>
              <div className="d-flex gap-2">
                <Form.Select
                  ref={productFromRef}
                  name="raw_pid"
                  value={formData.raw_pid}
                  onChange={handleFormChange}
                  onKeyDown={(e) => handleKeyDown(e, productToRef)}
                >
                  <option value="">Select Product</option>
                  {products.map((product, index) => (
                    <option key={index} value={product.id}>
                      {product.name} - {product.product_code}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Select Product To *</Form.Label>
              <div className="d-flex gap-2">
                <Form.Select
                  ref={productToRef}
                  name="finished_pid"
                  value={formData.finished_pid}
                  onChange={handleFormChange}
                  onKeyDown={(e) => handleKeyDown(e, qtyRef)}
                >
                  <option value="">Select Product</option>
                  {products.map((product, index) => (
                    <option key={index} value={product.id}>
                      {product.name} - {product.product_code}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>

          {/* Quantity */}
          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Quantity *</Form.Label>
              <Form.Control
                ref={qtyRef}
                name="allot_qty"
                type="number"
                value={formData.allot_qty}
                onChange={handleItemChange}
                onKeyDown={(e) => handleKeyDown(e, amountPerRef)}
                placeholder="Enter quantity"
                min="1"
              />

              <small className="text-muted">Press Enter to add item</small>
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Amount/KG *</Form.Label>
              <Form.Control
                ref={amountPerRef}
                name="amount_per_kg"
                type="number"
                value={formData.amount_per_kg}
                onChange={handleItemChange}
                onKeyDown={(e) => handleKeyDown(e, dateRef)}
                placeholder="Enter Amount/KG"
                min="1"
              />

              <small className="text-muted">Press Enter to add item</small>
            </Form.Group>
          </Col>

          <Col lg={3} md={3} sm={6}>
            <Form.Group>
              <Form.Label>Total Amount *</Form.Label>
              <Form.Control
                name="amount_total_kg"
                type="number"
                value={formData.amount_total_kg}
                readOnly
                placeholder="Total Amount"
              />

              <small className="text-muted">Press Enter to add item</small>
            </Form.Group>
          </Col>

          {/* Add Button */}
          {/* <Col lg={2} md={2} sm={6} className="d-flex align-items-end">
            <Button
              variant="primary"
              onClick={handleAddItem}
              className="w-100 d-flex align-items-center justify-content-center"
              disabled={!currentItem.product || !currentItem.quantity}
            >
              <FaPlus className="me-2" /> Add
            </Button>
          </Col> */}
          {/* Date */}
          <Col lg={3} md={3} sm={12}>
            <Form.Group>
              <Form.Label>Date *</Form.Label>
              <Form.Control
                ref={dateRef}
                name="allot_date"
                type="date"
                value={formData.allot_date}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, remarkRef)}
                // onKeyDown={(e) => handleKeyDown(e, null, handleAddItem)}
                isInvalid={!!errors.allot_date}
              />
              {renderError("allot_date")}
            </Form.Group>
          </Col>

          {/* Remarks */}
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Remarks (Optional)</Form.Label>
              <Form.Control
                ref={remarkRef}
                as="textarea"
                rows={2}
                name="note"
                value={formData.note}
                onChange={handleFormChange}
                // onKeyDown={(e) => handleKeyDown(e, null, handleAddItem)}
                placeholder="Any additional remarks..."
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Items Table */}


        {/* Submit Buttons */}
        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            type="submit"
            variant="primary"
            // disabled={workItems.length === 0}
            className="px-4"
          >
            Submit Allotment
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate("/workallotment")}

          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default WorkAllotmentReturn;